/**
 * RangePicker — pill row z 7 zakresami. Sticky horizontal scroll na mobile.
 */
import { type RangeKey, RANGE_LABELS } from '../../features/analytics/selectors';
import { haptic } from '../../lib/utils';

interface Props {
  value: RangeKey;
  onChange: (r: RangeKey) => void;
}

const ORDER: RangeKey[] = ['1d', '7d', '1m', '3m', '6m', '1y', 'all'];

export function RangePicker({ value, onChange }: Props) {
  return (
    <div
      role="tablist"
      aria-label="Zakres czasowy"
      className="-mx-4 px-4 overflow-x-auto scrollbar-thin"
    >
      <div className="inline-flex gap-1.5 bg-slate-100 dark:bg-slate-800/60 rounded-full p-1 min-w-max">
        {ORDER.map((r) => {
          const selected = r === value;
          return (
            <button
              key={r}
              type="button"
              role="tab"
              aria-selected={selected}
              onClick={() => {
                if (!selected) {
                  haptic('light');
                  onChange(r);
                }
              }}
              className={`px-3.5 py-1.5 rounded-full text-xs font-bold transition-all ${
                selected
                  ? 'bg-white dark:bg-slate-900 text-sky-700 dark:text-sky-300 shadow-card'
                  : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200'
              }`}
            >
              {RANGE_LABELS[r]}
            </button>
          );
        })}
      </div>
    </div>
  );
}
